
  window.onload = function () {
    cartDataCouponreverseToBeCalculated();
    shippingToBeCalculated();
  };
  // document.addEventListener('DOMContentLoaded', () => {
  //   const discountSubmitBtn = document.querySelector('.apply-discount-code');
  //   const discountCodeInput = document.querySelector('#discount_code');

  //   if (!discountSubmitBtn || !discountCodeInput) return;

  //   discountSubmitBtn.addEventListener('click', async (event) => {
  //     event.preventDefault();
  //     const discountCode = discountCodeInput.value.trim();

  //     if (!discountCode) {
  //       console.warn('No discount code entered.');
  //       return;
  //     }
  //     showLoading();
  //     try {
  //       fetch(`/discount/${discountCode}`, {
  //         method: 'GET',
  //         headers: { 'Content-Type': 'application/json' },
  //       })
  //       .then((response) => response.text())
  //       .then((responseJson) => {
  //         if (responseJson) {
  //           fetch('/cart.js')
  //           .then(response => response.json())
  //           .then(cart => {
  //             const discountamt=cart.total_discount;
  //             const checkingPromoCodeBackend = checkingPromoCodeBackendApplied(discountCode,discountamt);
  //             if(discountamt == 0 && checkingPromoCodeBackend=='error'){
  //               showflashmsg("invalid Promo code");
  //               hideLoading();
  //               return;
  //             }else{
  //               refreshCartPageNDrawerUI();
  //               couponcodeStoreLocalstorage(discountCode);
  //               couponCodeApplyChecking();
  //             }
  //           });
  //         } else {
  //           console.error(`Error applying discount: ${response.statusText}`);
  //         }
  //       })
  //       .catch(error => {
  //         console.error('Error:', error);
  //       });
  //     } catch (error) {
  //       console.error('Network error:', error);
  //     } finally {
  //       //hideLoading();
  //     }
  //   });
  // });
  function addDiscountToCart(){
    const discountCode = document.querySelector('#discount_code').value.trim();
      if (!discountCode) {
        console.warn('No discount code entered.');
        return;
      }
      showLoading();
      try {
        fetch(`/discount/${discountCode}`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        })
        .then((response) => response.text())
        .then((responseText) => {
          if (responseText) {
            fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              //console.log('Updated cart:', cart);
              const discountamt=cart.total_discount;
               const checkingPromoCodeBackend = checkingPromoCodeBackendApplied(discountCode,discountamt);
              if(discountamt == 0 || checkingPromoCodeBackend=='error'){
                showflashmsg("invalid Promo code");
                hideLoading();
                return;
              }else{
                refreshCartPageNDrawerUI();
                couponcodeStoreLocalstorage(discountCode);
                couponCodeApplyChecking();
              }
            });
          } else {
            console.error(`Error applying discount: ${response.statusText}`);
          }
        })
        .catch(error => {
          console.error('Error:', error);
        });
      } catch (error) {
        console.error('Network error:', error);
      } finally {
        //hideLoading();
      }
  }
  function refreshCartPageNDrawerUI(applyon=0) {
    const sectionsNeedToRender =  getSectionsNeedToRender();
    const rederingSections = sectionsNeedToRender.map((section) => section.section);
    setCartPageNDrawerUILoading();
    fetch(window.location.pathname + `?sections=${rederingSections.join()}`)
    .then(response => response.json())
    .then(data => {
      if (Object.keys(data).length) {
        sectionsNeedToRender.forEach(item => {
          if (item.section in data) {
            const html = new DOMParser().parseFromString(data[item.section], 'text/html');
            for (const selector of item.selectors) {
              const targetElement = document.querySelector(selector.source);
              const sourceElement = html.querySelector(selector.target);
              if (targetElement && sourceElement) {
                if (['#cart-icon-bubble', '#cart-icon-bubble-mob'].indexOf(selector.source) != -1) {
                  targetElement.innerHTML = sourceElement.innerHTML;
                } else {
                  targetElement.replaceWith(sourceElement);
                }
              }
            }
          }
        });
        hideLoading();
      }
    })
    .catch(error => {
      console.error('Error[refreshCartPageNDrawerUI]:', error);
    })
    .finally(() => {
      resetCartPageNDrawerUILoading();
    });
  }
  function showflashmsg(message, type = 'error'){
    const flashMessage = document.getElementById('flashMessage');

    // Update message content
    flashMessage.textContent = message;

    // Remove any previous type class
    flashMessage.className = 'flash-message';
    if (type) {
      flashMessage.classList.add(type);
    }

    // Show the message
    flashMessage.style.display = 'block';

    // Hide the message after 3 seconds
    setTimeout(() => {
      flashMessage.style.display = 'none';
    }, 3000);
  }
  function showLoading() {
    document.getElementById("couponloader").style.display = "block";
  }
  function hideLoading(){
    document.getElementById("couponloader").style.display = "none";
  }
  function setCartPageNDrawerUILoading(){

  }
function targetCartPageNDrawerElements() {
    return [
      '#main-cart-footer > .order-sum',
      '#cart-icon-bubble-mob',
    ];
}
function getSectionsNeedToRender() {
    return [
      {
        section: 'cart-drawer',
        selectors: [
          {
            source: 'cart-drawer-items',
            target: 'cart-drawer-items'
          },
          {
            source: '.cart-drawer__footer',
            target: '.cart-drawer__footer'
          }
        ]
      },
      {
        section: document.getElementById('main-cart-footer').dataset.id,
        selectors: [
          {
            source: '#main-cart-footer',
            target: '#main-cart-footer'
          }
        ],
      },
    ];
}
function resetCartPageNDrawerUILoading() {
    const targetElements = targetCartPageNDrawerElements();
    for (const targetElement of targetElements) {
        removeClassesFromElements(
        targetElement,
        ['loading', 'read-only']
        );
    }
}
const clearCartAttributes = async () => {
    try {
      let formData = new FormData();
      formData.append("discount", "");
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        const discountamt = data.total_discount;
          if(discountamt == 0){
            refreshCartPageNDrawerUI();
            couponcodeRemoveLocalstorage();
            couponCodeApplyChecking()
          }
        });
    } catch (error) {
        console.error('Network error:', error);
    } finally {
        //discountSubmitBtn.classList.remove('loading');
    }
};
function cuponapplyRemove(prms) {
  //alert(prms);
  const cuponApply = document.getElementById("cupon_apply");
  const cuponRemove = document.getElementById("cupon_remove");
  if (prms === "apply") {
    document.getElementById("discount_code").disabled = true;
    if (cuponApply) cuponApply.style.display = "none";
    if (cuponRemove) cuponRemove.style.display = "block";
  } else {
    document.getElementById("discount_code").disabled = false;
    document.getElementById("discount_code").value="";
    if (cuponApply) cuponApply.style.display = "block";
    if (cuponRemove) cuponRemove.style.display = "none";await
  }
}
function couponcodeStoreLocalstorage(code){
    if (code) {
        //alert(code);
        localStorage.setItem("couponCode", code);
        //console.log("Coupon code saved:", code);
    } else {
        console.error("No coupon code provided to store.");
    }
}

function couponcodeRemoveLocalstorage(){
  localStorage.removeItem("couponCode");
  localStorage.removeItem("freeShipping");
  localStorage.removeItem("discountNode");
}

function couponCodeApplyChecking(){
  const storedCode = localStorage.getItem("couponCode");
  if(storedCode){
      document.getElementById("discount_code").value = storedCode;
      document.getElementById("CartDrawer-Discount").value = storedCode;
      document.getElementById("discount_code").disabled = true;
      document.getElementById("CartDrawer-Discount").disabled = true;
      document.getElementById("CartDrawer-Discount").value = storedCode;
      document.getElementById("cupon_apply").style.display = "none";
      document.getElementById("cupon_remove").style.display = "block";
      document.getElementById("drawer_coupon_apply").style.display = "none";
      document.getElementById("drawer_coupon_remove").style.display = "block"; 
  }else{
      document.getElementById("discount_code").disabled = false;
      document.getElementById("CartDrawer-Discount").disabled = false;
      document.getElementById("discount_code").value="";
      document.getElementById("CartDrawer-Discount").value = "";
      document.getElementById("cupon_apply").style.display = "block";
      document.getElementById("cupon_remove").style.display = "none";
      document.getElementById("drawer_coupon_apply").style.display = "block";
      document.getElementById("drawer_coupon_remove").style.display = "none"; 
  }
}
function checkingPromoCodeBackendApplied(discountCode,discountamt) {
  const payload = {
    code: discountCode
  };
  const url = `${SHOPIFY_APP_BASE_URL}/discount-details-from-code`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  };
  fetch(url, options)
  .then(response => response.json())
  .then(response => {
    //console.log(response.data.codeDiscount.__typename);
    if(response.status=='ok'){
      localStorage.setItem("discountNode", JSON.stringify(response.data));
      if(response.data.codeDiscount.__typename == "DiscountCodeFreeShipping"){
        localStorage.setItem("freeShipping", "free");
        showflashmsg("Promo code For free shipping","info");
        shippingToBeCalculated();
      }else if(response.data.codeDiscount.__typename == "DiscountCodeBxgy" && discountamt == 0){
        showflashmsg("Promo code For Buy x AND Get Y","info");
      }else{
        showflashmsg("Promo code applied","info");
      }
      return "ok";
    }else{
      return "error";
    }
  })
  .catch(error => {
    console.error('Error: ', error);
    return "error";
  })
  .finally(() => {
    hideLoading();
  });
}
function shippingToBeCalculated(){
  const shippingtext= document.getElementById("main-cart-footer__shipping").innerHTML;
  const freeShipping = localStorage.getItem("freeShipping");
  const storedCode = localStorage.getItem("couponCode");
  setTimeout(() => {
    if(shippingtext == "To be calculated" && freeShipping =="free" && storedCode){
      document.getElementById("main-cart-footer__shipping").innerHTML="Free";
    }
  }, 2000);
}

function cartDataCouponreverseToBeCalculated() {
  const discountAmount = Number(document.getElementById("discount_amount")?.value || 0);
  const storedCode = localStorage.getItem("couponCode") || '';
  if (discountAmount > 0 && storedCode === "") {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        //console.log('Cart data:', cart);
        const appliedCodes = cart.discount_codes || [];       // → [{code:"cyber25", applicable:true}]
        const discountAmt = cart.total_discount || 0;         // → 259
        const onlyCode = appliedCodes.length > 0 ? appliedCodes[0].code : "";
        //console.log("Applied Code:", onlyCode);    // → cyber25
        checkingPromoCodeBackendApplied(onlyCode, discountAmt);
        couponcodeStoreLocalstorage(onlyCode);
        couponCodeApplyChecking();
      })
      .catch(error => {
        console.error('Error fetching cart data:', error);
        hideLoading();
      });
  }else{
    couponCodeApplyChecking();
  }
}

